import { FC } from 'react';
import { ErrorPageProps } from './interface';
import styles from './style/index.module.less';

export const ErrorPage: FC<ErrorPageProps> = (props) => {
  const { title, des, img, children, height } = props;
  return (
    <div className={styles['error-page-container']} style={{ height: height }}>
      <span className={styles['error-page-status-code']}>{title}</span>
      <span className={styles['error-page-desc']}>{des}</span>
      <div className={styles['error-page-button']}>{children}</div>
      <div className={styles['error-page-icon']}>
        {typeof img === 'string' ? (
          <img src={img} style={{ width: 210, height: 180 }} alt="error" />
        ) : (
          img
        )}
      </div>
    </div>
  );
};
